// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__v6FRt","slider__img":"Slider_slider__img__BmPpw"};